import client from "./sharedoClient";

const getFor = sharedoId => client.get(`api/wordaddin/related-content/${sharedoId}`);

export default {
    getFor
}